import React, { useRef, useEffect } from 'react';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';

const InternationalCooperation = () => {
    // Partner organizations with logo paths (replace with your actual paths)
    const partners = [
        // { name: "WIPO", logo: "/img/wipo logo.png", type: "Organization" },
        // { name: "ILO", logo: "/img/ilo logo.png", type: "Labour Organization" },
        { name: "UNIDO", logo: "/img/unido.png", type: "Development" },
        { name: "Government of Karnataka", logo: "/img/govtofkarnagtka.png", type: "Government" },
        { name: "SME Nigeria", logo: "/img/smenigeriaLogo.png", type: "SME Organization" },
        { name: "LEA", logo: "/img/lea logo.jpg", type: "Enterprise Authority" },
        { name: "UNCITRAL", logo: "/img/unicitral.jpg", type: "Legal Commission" },
        { name: "OSIBA Management", logo: "/img/osiba management.jpg", type: "Business Organization" },
        { name: "RMRDC", logo: "/img/rmrdc logo.jpg", type: "Research Council" },
        { name: "MSME India", logo: "/img/msme logo.png", type: "Government MSME" },
        { name: "UNCTAD", logo: "/img/unctad logo.png", type: "Trade & Development" },
        { name: "AWS", logo: "/img/aws logo.jpg", type: "Technology" },
        { name: "Bennett University", logo: "/img/bennet university.png", type: "University" },
        { name: "ESOSC", logo: "/img/esosc logo.png", type: "Organization" },
        { name: "Fincorp", logo: "/img/fincorp.png", type: "Finance" },
        { name: "Rahman Group", logo: "/img/rahman group.png", type: "Industry Group" },
        { name: "MANI", logo: "/img/mani_logo.jpg", type: "Industry Association" },
        { name: "Heylin", logo: "/img/heylin.jpg", type: "Organization" }
    ];
    // Duplicate partners array for seamless scrolling
    const scrollingPartners = [...partners, ...partners];

    // MoU countries with flag image paths (replace with your actual flag images)
    const mouCountries = [
        { name: 'Tanzania', flag: '/img/TanzaniaFlag.jpg', code: 'tz' },
        { name: 'Botswana', flag: '/img/BotswanaFlag.jpg', code: 'bw' },
        { name: 'Nigeria', flag: '/img/NigeriaFlag.jpg', code: 'ng' },
        { name: 'Eswatini', flag: '/img/EswatiniFlag.jpg', code: 'sz' },
        { name: 'Suriname', flag: '/img/SurinameFlag.jpg', code: 'sr' },
        { name: 'Angola', flag: '/img/AngolaFlag.jpg', code: 'ao' },
        { name: 'Zambia', flag: '/img/zambiaFlag.jpg', code: 'zm' },
    ];

    // Auto-scroll logic (pause on hover)
    const scrollRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;

        let animationFrame;
        let scrollPosition = 0;
        const scrollSpeed = 0.5; // pixels per frame

        const scroll = () => {
            if (!scrollContainer) return;
            // If hovered, don't advance
            if (scrollContainer.dataset.hover === 'true') {
                animationFrame = requestAnimationFrame(scroll);
                return;
            }

            scrollPosition += scrollSpeed;
            const maxScroll = scrollContainer.scrollWidth / 2; // half because duplicated
            if (scrollPosition >= maxScroll) {
                scrollPosition = 0;
            }
            scrollContainer.scrollLeft = scrollPosition;
            animationFrame = requestAnimationFrame(scroll);
        };

        animationFrame = requestAnimationFrame(scroll);

        return () => cancelAnimationFrame(animationFrame);
    }, []);

    return (
        <>
            <Navbar />
            <section className="bg-white py-4 md:py-8 font-sans antialiased">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Header */}
                    <div className="text-center md:text-left mb-12">
                        <h1 className="text-3xl md:text-4xl font-light text-gray-800 tracking-tight">
                            Our <span className="font-semibold" style={{ color: '#2b93d0' }}>Global Network</span>
                        </h1>
                        <div className="w-20 h-1 bg-yellow-400 mt-3 mb-6 mx-auto md:mx-0"></div>
                        <p className="text-gray-600 text-lg leading-relaxed max-w-4xl text-justify">
                            To support MSMEs globally, WASME is sincerely working to strengthen cross-border, transnational and inter-regional cooperation with all of our Members, Associates and Partners, Local Government Bodies, Regional Authorities, Financial Institutions/Banks, International Organizations, Civil Societies, Institutes, Chambers, Associations, Promotional Organizations, Financial Institutions, and MSMEs of various countries throughout the world.
                        </p>
                    </div>

                    {/* Partner Logos – Auto-scrolling Carousel */}
                    <div className="mb-20">
                        <h2 className="text-xl font-medium text-gray-700 mb-6 flex items-center">
                            <span className="w-2 h-2 bg-[#2b93d0] rounded-full mr-2"></span>
                            Prominent Partners & Associates
                        </h2>

                        <div
                            ref={scrollRef}
                            className="overflow-hidden cursor-grab active:cursor-grabbing"
                            onMouseEnter={() => { if (scrollRef.current) scrollRef.current.dataset.hover = 'true'; }}
                            onMouseLeave={() => { if (scrollRef.current) scrollRef.current.dataset.hover = 'false'; }}
                        >
                            <div className="flex gap-8" style={{ width: 'max-content' }}>
                                {scrollingPartners.map((partner, idx) => (
                                    <div
                                        key={`${partner.name}-${idx}`}
                                        className="flex-shrink-0 flex flex-col items-center group"
                                    >
                                        <div className="w-24 h-24 md:w-28 md:h-28 rounded-2xl bg-gray-50 border border-gray-200 p-3 flex items-center justify-center shadow-sm group-hover:shadow-md transition-all duration-300 group-hover:border-[#2b93d0]">
                                            <img
                                                src={partner.logo}
                                                alt={partner.name}
                                                className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
                                            />
                                        </div>
                                        <div className="mt-3 text-center">
                                            <span className="text-sm font-medium text-gray-700 group-hover:text-[#2b93d0] transition-colors">
                                                {partner.name}
                                            </span>
                                            <span className="block text-xs text-gray-400">{partner.type}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <p className="text-xs text-gray-400 mt-3 text-right">— scrolls automatically, pause on hover —</p>
                    </div>

                    {/* MoU Countries – Tilted Flag Cards with Permanent Names */}
                    <div>
                        <div className="flex items-center justify-between mb-8">
                            <h2 className="text-2xl font-light text-gray-800">
                                International <span className="font-semibold" style={{ color: '#2b93d0' }}>Memoranda of Understanding</span>
                            </h2>
                            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-3 py-1 rounded-full border border-yellow-200">
                                active agreements
                            </span>
                        </div>

                        {/* Flag cards arranged in a tilted, overlapping mosaic */}
                        <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-4 relative">
                            {mouCountries.map((country, index) => {
                                const tilt = index % 2 === 0 ? 'rotate-1' : '-rotate-1';
                                return (
                                    <div
                                        key={country.code}
                                        className={`group relative w-36 sm:w-40 md:w-44 lg:w-36 xl:w-40 transition-all duration-300 ease-out hover:z-10 hover:scale-105 ${tilt} hover:rotate-0`}
                                    >
                                        {/* Flag card */}
                                        <div className="bg-white rounded-lg overflow-hidden shadow-md border border-gray-200 hover:shadow-xl transition-shadow duration-300">
                                            <div className="h-24 sm:h-28 bg-gray-50 flex items-center justify-center p-2">
                                                <img
                                                    src={country.flag}
                                                    alt={`Flag of ${country.name}`}
                                                    className="max-h-full max-w-full object-contain"
                                                />
                                            </div>
                                            {/* Country name always visible */}
                                            <div className="py-2 px-1 text-center border-t border-gray-100">
                                                <p className="font-medium text-gray-800 text-sm">{country.name}</p>
                                            </div>
                                        </div>
                                        {/* Yellow MoU badge (appears on hover) */}
                                        <div className="absolute -top-2 -right-2 bg-yellow-400 text-yellow-900 text-[10px] font-bold px-2 py-0.5 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                            MoU
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Decorative footnote */}
                        <p className="text-sm text-gray-500 mt-1 border-t border-gray-100 pt-6 text-center md:text-left">
                            <span className="inline-flex items-center">
                                <span className="w-2 h-2 bg-yellow-400 rounded-full mr-2"></span>
                                In continuous expansion — new bilateral cooperations are being established.
                            </span>
                        </p>
                    </div>

                    {/* Minimalist world map accent */}
                   
                </div>
            </section>
            <Footer />
        </>

    );
};

export default InternationalCooperation;